import { render, staticRenderFns } from "./wappGeneral.vue?vue&type=template&id=746dfe77&scoped=true"
import script from "./wappGeneral.vue?vue&type=script&lang=js"
export * from "./wappGeneral.vue?vue&type=script&lang=js"
import style0 from "./wappGeneral.vue?vue&type=style&index=0&id=746dfe77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746dfe77",
  null
  
)

export default component.exports